import React, { useState, useEffect } from 'react';
import Icon from './AppIcon';

const CookieConsent = () => {
  const [showConsent, setShowConsent] = useState(false);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const hasAcceptedCookies = localStorage.getItem('cookieConsent');
    
    if (!hasAcceptedCookies) {
      // Show the popup after a short delay for better UX
      setTimeout(() => {
        setShowConsent(true);
        setTimeout(() => setIsVisible(true), 100);
      }, 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
    setTimeout(() => setShowConsent(false), 300);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
    setTimeout(() => setShowConsent(false), 300);
  };

  if (!showConsent) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center pointer-events-none">
      {/* Backdrop */}
      <div 
        className={`absolute inset-0 bg-black/20 backdrop-blur-sm transition-opacity duration-300 pointer-events-auto ${
          isVisible ? 'opacity-100' : 'opacity-0'
        }`}
        onClick={handleDecline}
      />

      {/* Cookie Consent Card */}
      <div 
        className={`relative max-w-4xl w-full m-4 mb-6 bg-white dark:bg-slate-800 rounded-2xl shadow-2xl border border-gray-200 dark:border-slate-700 overflow-hidden pointer-events-auto transition-all duration-300 transform ${
          isVisible ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'
        }`}
      >
        {/* Gradient Border Top */}
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-purple-600 via-blue-500 to-purple-600" />

        <div className="p-6 sm:p-8">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-6">
            {/* Icon */}
            <div className="flex-shrink-0">
              <div className="w-16 h-16 bg-gradient-to-br from-purple-600 to-blue-500 rounded-xl flex items-center justify-center">
                <Icon name="Cookie" size={32} className="text-white" />
              </div>
            </div>

            {/* Content */}
            <div className="flex-1">
              <h3 className="text-xl font-bold text-slate-900 dark:text-slate-100 mb-2">
                🍪 We Value Your Privacy
              </h3>
              <p className="text-sm text-slate-600 dark:text-slate-300 leading-relaxed">
                We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. 
                By clicking "Accept All Cookies", you consent to our use of cookies. You can manage your preferences 
                or learn more in our{' '}
                <a href="#" className="text-purple-600 dark:text-purple-400 hover:underline font-medium">
                  Cookie Policy
                </a>
                .
              </p>
            </div>

            {/* Actions */}
            <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
              <button
                onClick={handleAccept}
                className="inline-flex items-center justify-center px-6 py-3 bg-gradient-to-r from-purple-600 to-blue-500 text-white font-medium rounded-lg hover:from-purple-700 hover:to-blue-600 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
              >
                <Icon name="CheckCircle" size={18} className="mr-2" />
                Accept All
              </button>
              <button
                onClick={handleDecline}
                className="inline-flex items-center justify-center px-6 py-3 border-2 border-gray-300 dark:border-slate-600 text-slate-700 dark:text-slate-300 font-medium rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 transition-all duration-200"
              >
                <Icon name="X" size={18} className="mr-2" />
                Decline
              </button>
            </div>
          </div>

          {/* Additional Info */}
          <div className="mt-4 pt-4 border-t border-gray-200 dark:border-slate-700">
            <div className="flex flex-wrap gap-4 text-xs text-slate-500 dark:text-slate-400">
              <div className="flex items-center">
                <Icon name="Shield" size={14} className="mr-1 text-green-500" />
                Secure & Encrypted
              </div>
              <div className="flex items-center">
                <Icon name="Lock" size={14} className="mr-1 text-blue-500" />
                GDPR Compliant
              </div>
              <div className="flex items-center">
                <Icon name="Eye" size={14} className="mr-1 text-purple-500" />
                No Personal Data Sold
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
